'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * If we can inject stylesheets into the DOM.
 */
var canInject = exports.canInject = typeof window !== 'undefined';

var isTest = exports.isTest = process.env.NODE_ENV === 'test';
